import { shade } from "polished";
import styled, { css } from "styled-components";

import { stylesGlobalDefault } from "global/globalStyle";

interface IDivImportCertificate {
  disabled?: boolean;
}

export const LeftFormContainer = styled.div`
  margin-top: -4px;
`;
export const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 380px;
  padding: 0px 140px;
  margin-top: 4px;
`;
export const ContainerLogo = styled.div`
  align-self: center;
  display: flex;
  justify-content: center;
  margin-bottom: 33px;
  /* background-color: red; */
`;
export const Logo = styled.img``;

export const LinkContainer = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 16px;

  background: none;
  border: none;
`;

export const Container = styled.div`
  margin-top: 7px;
`;
export const LoadingContainer = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
`;

export const DivForgotPassword = styled.div`
  //margin-bottom: 12px;
  //background-color: red;
`;

export const DivImportCertificate = styled.div<IDivImportCertificate>`
  padding-top: 19px;
  ${(props) =>
    props.disabled &&
    css`
      opacity: 0.6;
      cursor: default !important;

      span {
        cursor: default;
      }
    `}
`;

export const ContainerForgot = styled.div`
  margin-top: 30px;
`;

interface ButtonProps {
  backgroundButton?: "primary" | "secondary";
}

export const Button = styled.button<ButtonProps>`
  background: ${(props) =>
    //props.backgroundButton !== "secondary" ? "#1D9BF0" : "#FFF"};
    props.backgroundButton !== "secondary"
      ? stylesGlobalDefault.blue
      : stylesGlobalDefault.white};
  color: ${(props) =>
    //props.backgroundButton !== "secondary" ? "#FFF" : "#1D9BF0"};
    props.backgroundButton !== "secondary"
      ? stylesGlobalDefault.white
      : stylesGlobalDefault.blue};
  border: ${(props) =>
    //props.backgroundButton !== "secondary" ? 0 : "2px solid #1D9BF0"};
    props.backgroundButton !== "secondary"
      ? 0
      : `2px solid ${stylesGlobalDefault.blue}`};
  width: 100%;
  height: 40px;
  border-radius: 50px;
  margin-top: 8px;
  //font-family: "Inter";
  font-family: ${stylesGlobalDefault.fontFamily};
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 125%;
  text-align: center;
  transition: 0.3s;

  &:hover {
    //background: ${shade(0.2, "#0D77BF")};
    background: ${shade(0.2, stylesGlobalDefault.blueDark)};
    transition: 0.2s;
    //color: #fff;
    color: ${stylesGlobalDefault.white};
    cursor: pointer;
  }
`;

export const MfaDescription = styled.p`
  color: ${stylesGlobalDefault.gray};
  font-size: 14px;
  text-align: center;
  margin-bottom: 20px;
  line-height: 1.5;
`;

export const MfaWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 20px;

  > div {
    width: 100%;
  }

  .verification-container {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  }

  .verification-character {
    width: 45px !important;
    height: 50px !important;
    border-radius: 8px;
    font-size: 24px;
    font-weight: 600;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid ${stylesGlobalDefault.inputsBorderFocusOff};
    transition: all 0.2s ease-in-out;
    color: ${stylesGlobalDefault.blackMenu1};
    background-color: ${stylesGlobalDefault.white};
  }

  .verification-character--inactive {
    border: 2px solid ${stylesGlobalDefault.inputsBorderFocusOff};
    background-color: ${stylesGlobalDefault.white};
  }

  .verification-character--selected {
    border: 2px solid ${stylesGlobalDefault.blue};
    box-shadow: 0 0 5px rgba(29, 155, 240, 0.3);
  }

  .verification-character--filled {
    border: 2px solid ${stylesGlobalDefault.blue};
    background-color: ${stylesGlobalDefault.white};
  }
`;

export const MicrosoftButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  height: 40px;
  border-radius: 50px;
  border: 2px solid #e0e0e0;
  background: ${stylesGlobalDefault.white};
  color: #5e5e5e;
  font-family: ${stylesGlobalDefault.fontFamily};
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: 0.2s;
  margin-top: 8px;

  &:hover {
    background: #f5f5f5;
    border-color: #0078d4;
    color: #0078d4;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const Divider = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin: 16px 0;
  gap: 12px;

  &::before,
  &::after {
    content: "";
    flex: 1;
    height: 1px;
    background: #e0e0e0;
  }

  span {
    font-size: 12px;
    color: ${stylesGlobalDefault.gray};
    white-space: nowrap;
  }
`;

export const ResendCodeButton = styled.button`
  background: none;
  border: none;
  color: ${stylesGlobalDefault.blue};
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  cursor: pointer;
  padding: 8px;
  margin-bottom: 10px;
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    color: ${shade(0.2, stylesGlobalDefault.blue)};
    text-decoration: underline;
  }

  &:disabled {
    color: ${stylesGlobalDefault.gray};
    cursor: not-allowed;
    opacity: 0.6;
  }
`;
